// import { Component } from '@angular/core';

import { Component, OnInit, OnDestroy, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormSubmissionService } from '../../_services/form-submission.service';
import { FormDataService } from '../../_services/form-data.service';
import { CssInjectorService } from '../../_services/css-injector.service';
import { HttpClient } from '@angular/common/http';
import { ThankYouTelemetryService } from '../../_services/thank-you-telemetry.service';
import { ThankYouRouteService } from '../../_services/thank-you-route.service';

declare global {
  interface Window {
    MAO?: any;
    Mao?: any;    
    setMAOLocalStorageValue?: (key: string, value: any) => void;
    InitMAO?: (target: string, n?: number) => void;
    maoInit?: (config: any) => any;
  }
}

@Component({
  selector: 'app-thank-you-page-mao',
  standalone: false,
  templateUrl: './thank-you-page-mao.component.html',
  styleUrl: './thank-you-page-mao.component.css'
})
export class ThankYouPageMaoComponent implements OnInit, OnDestroy {
    private scriptEl?: HTMLScriptElement;
    private scriptLoadedPromise?: Promise<void> | null = null;
    private cssFaceLiftFileContent: string = '';
    private cssFaceliftPromise: Promise<string> | null = null;
    private isBrowser = false;
    currentLead: any = null;
    thankyouRoute: string = '';

  constructor(
    private cssInjectorService : CssInjectorService,
    private http: HttpClient,
    private formSubmissionService: FormSubmissionService,
    private formDataService: FormDataService,
    public thankYouTelemetryService: ThankYouTelemetryService,
    private renderer: Renderer2,
    public ThankYouRouteService: ThankYouRouteService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }  

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }

    this.ThankYouRouteService.thankYouPageRoute$.subscribe(async (thanksSubId) => {
      
      const thankYouRoute = await this.ThankYouRouteService.resolve(thanksSubId);
      this.thankyouRoute = thankYouRoute.provider.toLowerCase();
      if((thankYouRoute.provider || '').toLowerCase() == 'mao') {
        this.loadExternalScript();
        this.getCSSFacelift();
        this.formSubmissionService.getLeadObservable().subscribe(async lead => {
          if(lead && Object.keys(lead).length > 0) {
            this.currentLead = lead;

            var cashOut = 'No';
            if (lead.CashOut * 1 > 0) {
                cashOut = 'Yes';
            }

            var vaStatus = 'No';
            if (lead.VAStatus && lead.VAStatus == 'true') {
                vaStatus = 'Yes';
            }

          if ((lead.LoanAmount * 1) >= (lead.EstimatedHomeValue * 0.95)) {
                lead.EstimatedHomeValue = lead.LoanAmount * 1.3;
                lead.EstimatedHomeValue = Math.trunc(lead.EstimatedHomeValue);
            }

            var CR = this.capitalizedString(lead.CreditRating)

            this.setMAOLocalStorageValue("zipcode", lead.Zip);
            this.setMAOLocalStorageValue("State", lead.State);
            this.setMAOLocalStorageValue("creditscore", CR);
            this.setMAOLocalStorageValue("loanbalance", lead.LoanAmount);
            this.setMAOLocalStorageValue("propertyvalue", lead.EstimatedHomeValue);
            this.setMAOLocalStorageValue("CashOut", cashOut);        
            this.setMAOLocalStorageValue("MediaChannel", "SMS");
            this.setMAOLocalStorageValue("MilitaryStatus", vaStatus);
            this.setMAOLocalStorageValue("PropertyType", lead.PropertyType);
            this.setMAOLocalStorageValue("FName", lead.FName);
            this.setMAOLocalStorageValue("LName", lead.LName);
            this.setMAOLocalStorageValue("Email", lead.Email);
            this.setMAOLocalStorageValue("Phone", lead.Phone);
            this.setMAOLocalStorageValue("Address", lead.Address);
            this.setMAOLocalStorageValue("City", lead.City);


            if(lead.ThanksSubID=='MAOET'){
              this.setMAOLocalStorageValue("SourceID", "113_CHL");
            }
            else { 
              if(lead.VerticalID == 6) {
                console.log('113_HLHS');
                this.setMAOLocalStorageValue("SourceID", "113_HLHS");

              } else {
                console.log('113_HL');
                this.setMAOLocalStorageValue("SourceID", "113_HL");

              }
            }
            this.setMAOLocalStorageValue("CustomVar1", "MAOHL");
            
            
            this.initMAO('target', 1);
            await this.getCSSFacelift();
            this.cssInjectorService.injectCSS('mao-thankyoupage-facelift', this.cssFaceLiftFileContent);        
          }
          
        });


      }
    });

  }

  ngOnDestroy(): void {
    if (!this.isBrowser) {
      return;
    }

    if (this.scriptEl) {
      this.renderer.removeChild(this.document.body, this.scriptEl);
    }
  }


  private loadExternalScript(): Promise<void> {  
    const selector = "script[src='https://cdn.myadoptimizer.com/maojsfiles/landingpagesjs/fe2bfab1-b4ef-ef11-90c9-000d3a925ca4.js']";
    if (this.document.querySelector(selector)) {
      this.scriptLoadedPromise = Promise.resolve();
      return this.scriptLoadedPromise;
    }

    this.scriptLoadedPromise = new Promise<void>((resolve, reject) => {
      this.scriptEl = this.renderer.createElement('script') as HTMLScriptElement;
      this.scriptEl.type = 'text/javascript';
      this.scriptEl.src = 'https://cdn.myadoptimizer.com/maojsfiles/landingpagesjs/fe2bfab1-b4ef-ef11-90c9-000d3a925ca4.js';
      this.scriptEl.async = true;

      this.scriptEl.onload = () => resolve();
      this.scriptEl.onerror = () => reject(new Error('Failed to load external script'));

      this.renderer.appendChild(this.document.body, this.scriptEl);
    });  
    return this.scriptLoadedPromise;
  }

  async callScriptFunction(name: string, ...args: any[]): Promise<any> {
    try {
      await (this.scriptLoadedPromise ?? this.loadExternalScript());
    } catch (err) {
      return Promise.reject(err);
    }

    const globalObj = (window as any);

    if (typeof globalObj[name] === 'function') {
      return globalObj[name](...args);
    }

    const nsCandidates = ['MAO', 'Mao', 'mao', 'myAdOptimizer'];
    for (const ns of nsCandidates) {
      if (globalObj[ns] && typeof globalObj[ns][name] === 'function') {
        return globalObj[ns][name](...args);
      }
    }

    return Promise.reject(new Error(`Function ${name} not found on window or known namespaces`));
  }  

  async setMAOLocalStorageValue(key: string, value: any): Promise<void> {
    await (this.scriptLoadedPromise ?? this.loadExternalScript());

    const win = window as any;
    if (typeof win.setMAOLocalStorageValue === 'function') {
      return win.setMAOLocalStorageValue(key, value);
    }

    if (win.MAO && typeof win.MAO.setMAOLocalStorageValue === 'function') {
      return win.MAO.setMAOLocalStorageValue(key, value);
    }

    return Promise.reject(new Error('setMAOLocalStorageValue not found'));
  }  

  async initMAO(target: string, n: number = 1): Promise<any> {
    await (this.scriptLoadedPromise ?? this.loadExternalScript());

    const win = window as any;
    if (typeof win.InitMAO === 'function') {
      return win.InitMAO(target, n);
    }

    if (win.MAO && typeof win.MAO.InitMAO === 'function') {
      return win.MAO.InitMAO(target, n);
    }

    try {
      return await this.callScriptFunction('InitMAO', target, n);
    } catch (err) {
      return Promise.reject(new Error('InitMAO not found'));
    }
  }  

  // Move this function to Utils
  private capitalizedString(string: string): string {
    if (!string) return string;
    
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }  


  async getCSSFacelift(): Promise<string> {
    if (!this.isBrowser) {
      return '';
    }

    if (this.cssFaceLiftFileContent) {
      return this.cssFaceLiftFileContent;
    }

    if (this.cssFaceliftPromise) {
      return this.cssFaceliftPromise;
    }

    const filePath = '/assets/css/thank-you-page/mao-facelift-v1.css';

    this.cssFaceliftPromise = new Promise<string>((resolve, reject) => {
      this.http.get(filePath, { responseType: 'text' }).subscribe({
        next: (data) => {
          this.cssFaceLiftFileContent = data;
          resolve(data);
        },
        error: (err) => {
          this.cssFaceliftPromise = null;
          console.error('Error reading file:', err);
          reject(err);
        }
      });
    });

    return this.cssFaceliftPromise;
  }

}
